/**
 * ControlBlock — a labeled control wrapper (label + required marker + inline
 * error) that, unlike `Field`, does NOT wrap children in a <label>. Wrapping
 * would hijack the RegionTreeSelect trigger / native select accessible name.
 *
 * Extracted from LocationStep so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import { useId, type ReactNode } from 'react';

import { labelControl, linkControlToError } from './link-control-to-error';

export function ControlBlock({
  label,
  error,
  required = true,
  children,
}: {
  label: string;
  error?: string;
  required?: boolean;
  children: ReactNode;
}) {
  const errorId = useId();
  const labelId = useId();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span id={labelId} style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}>
        {label}
        {required && <span style={{ color: 'var(--nb-warn)' }}> *</span>}
      </span>
      {linkControlToError(labelControl(children, labelId, required), errorId, error)}
      {error && (
        <span id={errorId} style={{ fontSize: 10.5, color: 'var(--nb-risk)' }}>
          {error}
        </span>
      )}
    </div>
  );
}
